import { graphql, useStaticQuery } from 'gatsby';

// Better to have a list of common queries in one place than to have the same query repeated in multiple components.
// This also allows us to use the query in providers and pass the data down via context, which is better for performance than having multiple components all run the same query with useStaticQuery.
export const useListingSliderQuery = () => {
    const data = useStaticQuery(graphql`
{
    allSmartTagsListingSlider(
        filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
    ) {
        edges {
          node {
            id
            title
            subtitle
            link
            linkText
            flush
            padding
            background
            backgroundImage
            backgroundProps
            Category {
              object {
                permalink
                id
              }
            }
            Audience {
              ...AudienceRelationshipDetailsFragment
            }
          }
        }
    }
    allSimpleviewListing(
      filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
      sort: {randSort: ASC}
    ) {
        edges {
          node {
            Category {
              object {
                permalink
                id
              }
            }
            id
            photo
            companyName
            description
            permalink
            uri
          }
        }
    }
}
`);
    return { data };
};